import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.css";
import reportWebVitals from "./reportWebVitals";
import ResetPass from "./pages/ResetPass";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router basename={'/reset'}>
      <Switch>
        <Route>
          <ResetPass />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
